export const PHONE_NUMBER_VALIDATION_TYPES = Object.freeze({
  REQUIRED: 'required',
  VALIDATE: 'validate',
});
